<p-table [value]="templates">
    <ng-template pTemplate="header">
        <tr>
            <th style="width:auto"> {{ 'Configuration.CRM.Name' | transloco }} </th>
            <th style="width:auto"> {{ 'Configuration.CRM.Channel' | transloco }} </th>
            <th style="width:auto"> {{ 'Configuration.CRM.Created_By' | transloco }} </th>
            <th style="width:auto"> {{ 'Configuration.CRM.Last_Modified' | transloco }} </th>
            <th style="width:auto"> {{ 'Configuration.CRM.Is_Active' | transloco }} </th>
            <th style="width:auto"> {{ 'Configuration.CRM.Action' | transloco }} </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-template let-i="rowIndex">
        <tr>
            <td> {{ template.name }} </td>
            <td> {{ template.channelName }} </td>
            <td> {{ template.createdByName }} </td>
            <td> {{ template.lastUpdatedDate | localDate: 'MM/DD/YYYY' }} </td>
            <td> {{ template.isActive ? answertypeConstants.Yes: answertypeConstants.No }} </td>
            <td class="action">
                <span class="btnBars p-mr-0" (click)="showUpdateTemplateModal(template)" pTooltip="Edit"
                    tooltipPosition="top">
                    <i class="pi pi-pencil"></i>
                </span>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="8"> {{ noDataTemplate }} </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="{{ templateHeader }} - {{ selectedTemplate?.name }}"
    [(visible)]="displayUpdateTemplate" [modal]="true" [responsive]="true" [style]="{width: '60em'}">
    <form #templateForm="ngForm">
        <div class="card">
            <div class="p-grid" *ngFor="let section of selectedTemplate?.sections; let i = index">
                <div class="p-col-12">
                    <div class="p-d-flex p-jc-between p-ai-center p-mb-2 p-pl-2 p-pr-2" *ngIf="i == 0">
                        <h6 >
                            {{ 'Configuration.CRM.Label_Name' | transloco }}
                        </h6>
                        <h6 >
                            {{ 'Configuration.CRM.Edit_Label_Name' | transloco }}
                        </h6>
                        <div class="p-d-flex p-jc-between p-ai-center" style="gap: 24px;">
                            <span class="btnBars" style="cursor: default;"
                                pTooltip="{{'Configuration.CRM.Fields' | transloco}}" tooltipPosition="top">
                                <i class="pi pi-file" style="font-size: 15px;"></i>
                            </span>
                            <span class="btnBars" style="cursor: default;"
                                pTooltip="{{'Configuration.CRM.Setting' | transloco}}" tooltipPosition="top">
                                <i class="pi pi-cog" style="font-size: 15px;"></i>
                            </span>
                            <!-- <span  class="btnBars" style="cursor: default;"
                                pTooltip="Child Fields" tooltipPosition="top" *ngIf="isEnabledParentChildTemplate">
                                <i class="pi pi-file-check" style="font-size: 15px;"></i>
                            </span>
                            <span class="btnBars" style="cursor: default;"
                                pTooltip="Unique Fields" tooltipPosition="top">
                                <i class="pi pi-key" style="font-size: 15px;"></i>
                            </span> -->
                        </div>
                    </div>
                    <p-table [value]="section.fields" dataKey="code" styleClass="editable">
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="header p-col-4">
                                    <h5> {{ section.name }} </h5>
                                </th>
                                <th class="header p-col-6"></th>
                                <th style="width: 50px;" class="p-text-center header">
                                </th>
                                <th style="width: 50px;" class="p-text-center header">
                                </th>
                                <!-- <th style="width: 50px;" class="p-text-center header" *ngIf="isEnabledParentChildTemplate" >
                                </th>
                                <th style="width: 50px;" class="p-text-center header">
                                </th> -->
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-field let-rowIndex="rowIndex">
                            <tr>
                                <td> {{ field.name }}
                                    <span style="color: red;" *ngIf="field.isRequired">*</span>
                                    <button type="button" pButton pRipple [pRowToggler]="field"
                                        style="width: 1.25rem;height: 1.25rem;"
                                        class="p-button-text p-button-rounded p-p-0 p-ml-2"
                                        (click)="field.showChildren = !field.showChildren;"
                                        [icon]="field.showChildren ? 'pi pi-minus' : 'pi pi-plus'"
                                        *ngIf="field.childFields?.length">
                                    </button>
                                </td>
                                <td pEditableColumn class="action">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="field.labelName"
                                                (focusout)="setUpdatedFields($event, i, rowIndex)">
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <div class="p-d-flex p-ai-center" pTooltip="Edit Label Name" tooltipPosition="top">
                                                <i class="pi pi-pen-to-square p-mr-2 hyper-link"></i> {{ field.labelName }}
                                            </div>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td class="p-text-center action">
                                    <p-checkbox *ngIf="!field.childFields.length" [ngModelOptions]="{standalone: true}"
                                        [value]="field" [(ngModel)]="field.enabledInForm" binary="true" ngDefaultControl
                                        [disabled]="(field.isRequired && !field.isCustom) || field.code =='contact name' ||
                                        (field.name == 'Account Owner' && territoryConfig.isTerritoryManagementEnabled)"
                                        (onChange)="setUpdatedFields($event, i, rowIndex , 'enabledInForm')"
                                        pTooltip="Enabled In Form" tooltipPosition="top">
                                    </p-checkbox>
                                </td>
                                <td class="p-text-center action">
                                    <p-checkbox *ngIf="!field.childFields.length && field.enabledInForm" binary="true"
                                        ngDefaultControl (onChange)="setUpdatedFields($event, i, rowIndex)"
                                        [ngModelOptions]="{standalone: true}" [value]="field"
                                        [(ngModel)]="field.enabledColumnSetting"
                                        [disabled]="((field.name == 'Name' && moduleId === 1) || (field.name == 'Account Name' &&
                                            moduleId === 2)) && !field.isCustom"
                                            pTooltip="Enabled Column Setting" tooltipPosition="top">
                                    </p-checkbox>
                                </td>
                                <!-- <td class="p-text-center action"  *ngIf="isEnabledParentChildTemplate">
                                    <p-checkbox *ngIf=" field.enabledInForm && !field.childFields.length"  [ngModelOptions]="{standalone: true}"
                                        [value]="field" [(ngModel)]="field.enabledInChildAccount" binary="true" ngDefaultControl

                                        (onChange)="setUpdatedFields($event, i, rowIndex)"
                                        pTooltip="Enabled In Child Account" tooltipPosition="top">
                                    </p-checkbox>
                                </td> -->
                                <!-- <td class="p-text-center action" >
                                    <p-checkbox *ngIf="!field.childFields.length && field.enabledInForm" binary="true"
                                        ngDefaultControl (onChange)="setUpdatedFields($event, i, rowIndex)"
                                        [ngModelOptions]="{standalone: true}" [value]="field"
                                        [(ngModel)]="field.isUnique"
                                        pTooltip="Is Unique" tooltipPosition="top"
                                        >
                                    </p-checkbox>
                                </td> -->
                            </tr>

                            <ng-container *ngIf="field?.showChildren">
                                <tr *ngFor="let s of field.childFields; let j = index;" class="child-color">
                                    <td> {{ s.name }} </td>
                                    <td pEditableColumn class="action">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <input pInputText type="text" [ngModelOptions]="{standalone:true}" [(ngModel)]="s.labelName"  (focusout)="setUpdatedFields($event, i, rowIndex, j)">
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                <div class="p-d-flex p-ai-center" pTooltip="Edit Label Name" tooltipPosition="top">
                                                    <i class="pi pi-pen-to-square p-mr-2 hyper-link"></i> {{ s.labelName }}
                                                </div>
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td class="p-text-center action">
                                        <p-checkbox [ngModelOptions]="{standalone: true}"
                                            [disabled]="field.isRequired && !field.isCustom" [value]="s"
                                            ngDefaultControl [(ngModel)]="s.enabledInForm" binary="true"
                                            (onChange)="setUpdatedFields($event, i, rowIndex, j)">
                                        </p-checkbox>
                                    </td>
                                    <td class="p-text-center action">
                                        <p-checkbox [ngModelOptions]="{standalone: true}" *ngIf="s.enabledInForm "
                                            [disabled]="field.isRequired && !field.isCustom" [value]="s"
                                            ngDefaultControl [(ngModel)]="s.enabledColumnSetting" binary="true"
                                            (onChange)="setUpdatedFields($event, i, rowIndex, j)">
                                        </p-checkbox>
                                    </td>
                                </tr>
                            </ng-container>

                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </form>

    <p-footer>
        <button type="button" pButton (click)="displayUpdateTemplate = false;"
            label="{{'Configuration.CRM.Cancel' | transloco}}" class="p-button-secondary">
        </button>
        <button type="button" pButton label="{{'Configuration.CRM.Save' | transloco}}"
             (click)="updateTemplateFields()">
        </button>
    </p-footer>

    <!-- [disabled]="!updatedFields.length" -->
</p-dialog>

<p-dialog [showHeader]="true" [(visible)]="duplicateMinMsg" [modal]="true" [closable]="false"
    [style]="{width: '350px'}">
    <h6 class="p-text-center error-msg">Minimum one duplicate field required!</h6>
    <div class="p-mt-5 p-text-center">
        <button type="button" pButton (click)="duplicateMinMsg=false" label="Ok" class="p-button-secondary"></button>
    </div>
</p-dialog>
